// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';

export const FORM_SUBMITTED = 'FORM_SUBMITTED';

export const receiveForm = (formName, form) => ({
  type: FORM_SUBMITTED,
  formName,
  form,
});

export const getRepeatablePath = (key, state) => {
  const componentId = get(state, 'form.id');
  const propPath = key.split('.').slice(1);
  return [componentId, ...propPath];
};
